export default __webpack_public_path__ + "b1221a63c970322ac6cd94bffbc2449b.png";